export default {
  props: {
    componentName: {
      default: '',
      type: String,
    },
    componentType: {
      default: 0,
      type: Number,
    },
    componentTitle: {
      default: '',
      type: String,
    },
    columnTitle: {
      default: '',
      type: String,
    },
    columnIntro: {
      default: '',
      type: String,
    },
    bgImageUrl: {
      default: '',
      type: String,
    },
    bgAlt: {
      default: '',
      type: String,
    },
    iconList: {
      default: () => [],
      type: Array,
    },
  },
}
